var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"page--listen mt-2",class:{
    'pa-0': _vm.$voicer.isDesktopOrTablet,
    'pb-5': _vm.$voicer.isDesktopOrTablet,
  }},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('w-player')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }